<script>
    import BagProduct from './BagProduct.svelte';
    import BagSummary from './BagSummary.svelte';

    let bag = [
                {
                    "id":"xyz123-1",
                    "quantity":2,
                    "name": "Kashmiri Apple",
                    "regionalName": "কাশ্মীৰী আপেল",
                    "image":"../images/products/kashmiri-apple.webp",
                    "imageAlt":"An Kashmiri Apple",
                    "mrp":100,
                    "offeredPrice":80,
                    "attributes":{
                        "weight":"1kg",
                        "color":"Black"
                    }
                },
                {
                    "id":"xyz123-1",
                    "name": "Kashmiri Apple",
                    "regionalName": "কাশ্মীৰী আপেল",
                    "quantity":2,
                    "image":"../images/products/kashmiri-apple.webp",
                    "imageAlt":"An Kashmiri Apple",
                    "mrp":100,
                    "offeredPrice":80,
                    "attributes":{
                        "weight":"1kg",
                        "color":"Black"
                    }
                },
                {
                    "id":"xyz123-1",
                    "name": "Kashmiri Apple",
                    "regionalName": "কাশ্মীৰী আপেল",
                    "quantity":5,
                    "image":"../images/products/kashmiri-apple.webp",
                    "imageAlt":"An Kashmiri Apple",
                    "mrp":100,
                    "offeredPrice":80,
                    "attributes":{
                        "weight":"1kg",
                        "color":"Black"
                    }
                },
                {
                    "id":"xyz123-1",
                    "name": "Kashmiri Apple",
                    "regionalName": "কাশ্মীৰী আপেল",
                    "quantity":2,
                    "image":"../images/products/kashmiri-apple.webp",
                    "imageAlt":"An Kashmiri Apple",
                    "mrp":100,
                    "offeredPrice":80,
                    "attributes":{
                        "weight":"1kg",
                        "color":"Black"
                    }
                },
            ]

    let itemCount = bag.length;
    let bagSubtotal = 0;

    function subtotal() {
        for( let product of bag ) {
            bagSubtotal += product.offeredPrice * product.quantity;
        }
    }
    subtotal();
    console.log(bagSubtotal)



</script>

<style>
    .bag{
        position: fixed;
        transform: scale(0, 0);
        visibility: hidden;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        padding-top: 5rem;
        background-color: #FFFFFF;
        box-sizing: border-box;
        z-index: 5;
        opacity: 0;
        transition: all 0.2s;
        overflow-y: scroll;
    }
    .bag:target{
        visibility: visible;
        transform: scale(1, 1);
        opacity: 1;
        transition: all 0.2s;
    }
    .back{
        position: absolute;
        top: 1rem;
        left: 1rem;
        background-color: #FFFFFF;
        color: #666666;
        text-decoration: none;
        z-index: 6;
    }
    .bag-title{
        padding-bottom: 1rem;
        border-bottom: 1px solid #EEEEEE;
    }
</style>

<section id="bag" class="bag">

     <a class="button back" href="#back">Back</a>

    <h2 class="bag-title">Review Bag ({itemCount} items)</h2>

    {#each bag as productx}
        <BagProduct product={productx}/>
    {/each}

    <BagSummary bagSubtotal = {bagSubtotal} />

    <button class="button cta">Place Order ₹3,260</button>
</section>
